import { MiniSwiper } from 'global/components/swipers/MiniSwiper';
import _ from 'lodash';
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext';
import { _matchLsTypes } from 'projectSpecific/sports/cnr/reducers/SportsDataReducer';
import { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { _matchDisplayTypes } from '../matches/MatchContent';
import { MatchesDate } from '../matches/MatchesDate';
import { SectionDateHeader } from './SectionDateHeader';
import { SectionHeader } from './SectionHeader';
import { gEnums } from 'global/enums/globalEnums';
import { uniqueKey } from 'global/common/keys';

export const LevelSchedule = ({ teamKey }) => {

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { matches_info } = sportsSeason_state ?? {}
  const { matches_groupInfo } = matches_info ?? {}
  const { levelSectionDateMatches } = matches_groupInfo ?? {}
  const _lsdms = _.omit(levelSectionDateMatches, [_matchLsTypes.Non, _matchLsTypes.nonDistrict, _matchLsTypes.nonSection])

  const [activeKey, setActiveKey] = useState()

  const handleActiveKey = (index, key) => setActiveKey(key)

  const levelItems = useMemo(() => {
    const _levelItems = []
    _.forEach(_lsdms, (levelGroup, levelKey) => {
      const divs = <Level_Schedule
        levelGroup={levelGroup}
        levelKey={levelKey}
        activeKey={activeKey}
      />
      _levelItems.push(
        {
          key: levelKey,
          caption: levelKey,
          content: <div className='level-matches' key={uniqueKey('ls', levelKey)}>{divs}</div>
        }
      )
    })
    const _level_items = _.sortBy(_levelItems, 'key').reverse()
    return _level_items
  }, [])

  const content_schedule_levelMatches = useMemo(() => {
    return <MiniSwiper
      includeButtons={true}
      swipeItems={levelItems}
      showButtons={true}
      handleActiveKey={handleActiveKey}
    />
  }, [levelSectionDateMatches, levelItems, activeKey])

  return content_schedule_levelMatches

}

const Level_Schedule = ({ levelGroup, levelKey, activeKey }) => {

  const levelDateRef = useRef({})
  const hasScrolled = useRef({})

  useEffect(() => {
    const ldr = levelDateRef.current?.[levelKey]
    if (!ldr || activeKey !== levelKey || hasScrolled.current?.[levelKey]) return
    hasScrolled.current[levelKey] = true
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        ldr.scrollIntoView({
          behavior: 'instant',   // 👈 NOT 'instant'
          block: 'start',
          alignToTop: true
        })
      })
    })
  }, [activeKey])


  const getClosestDateKey = (dateKeys) => {
    const today = new Date()
    today.setHours(0, 0, 0, 0)

    return _.minBy(dateKeys, dateKey => {
      const d = new Date(dateKey)
      return Math.abs(d - today)
    })
  }

  const parseMMDDYYYY = (str) => {
    const [m, d, y] = str.split('/')
    return new Date(+y, +m - 1, +d)
  }

  const ldss = (levelGroup) => {
    return Object.keys(levelGroup)
      .sort((a, b) => parseMMDDYYYY(a) - parseMMDDYYYY(b))
  }

  const _levelGroup = ldss(levelGroup)
  const dateKeys = Object.keys(levelGroup)
  const closestDateKey = getClosestDateKey(dateKeys)
  const divs = []

  _.forEach(_levelGroup, (dateKey) => {
    const dateGroup = levelGroup[dateKey]
    const attachRef = dateKey === closestDateKey
    divs.push(<SectionDateHeader
      levelKey={levelKey}
      startDate={dateKey}
      matches={dateGroup}
      attachRef={attachRef}
      levelDateRef={levelDateRef}
    />)
    _.forEach(dateGroup, (sectionMatches, sectionKey) => {
      const _sectionHeader = <SectionHeader
        sectionKey={sectionKey}
        levelKey={levelKey}
      />
      const _sectionMatches = <MatchesDate
        dateKey={dateKey}
        levelKey={levelKey}
        matchDisplayType={_matchDisplayTypes.levelMatches}
        matches={sectionMatches}
        matchScheduleDisplayType={gEnums.matchScheduleDisplayTypes.levelTabsFull}
        sectionKey={sectionKey}
      />
      const div_section = <div className='match-date-matches'>
        {_sectionHeader}
        {_sectionMatches}
      </div>
      divs.push(div_section)
    })
  })

  return divs

}